import { combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";

import accountsSlice from "../features/accounts/accountSlice";
import alertSlice from "../features/alert/alertSlice";
import areasSlice from "../features/areas/areasSlice";
import authSlice from '../features/auth/authSlice';
import careersSlice from "../features/careers/careersSlice";
import campusSlice from "../features/campus/campusSlice";
import calendarSlice from "../features/calendars/calendarsSlice";
import departmentSlice from "../features/department/departmentSlice";
import eventsSlice from "../features/events/eventsSlice";
import odsSlice from '../features/ods/odsSlice';
import placesSlice from "../features/places/placesSlice";
import progressSlice from '../features/progress/pogressSlice';
import recordSlice from "../features/records/recordSlice";
import searchSlice from "../features/search/searchSlice";
import staffSlice from "../features/staff/staffSlice";
import studentsSlice from "../features/students/studentsSlice";
import supervisionSlice from "../features/supervision/supervisionSlice";
import modalitiesSlice from '../features/modalities/modalitiesSlice';
import modalSlice from "../features/modal/modalSlice";
import typesSlice from "../features/types/typesSlice";
import teachersSlice from "../features/teachers/teachersSlice";
import thematicsSlice from '../features/thematics/thematicsSlice'

const persistConfig = {
    key: 'root',
    version: 1,
    storage
}

const appReducer = combineReducers({
    accounts: accountsSlice,
    alert: alertSlice,
    areas: areasSlice,
    auth: authSlice,
    calendars: calendarSlice,
    campus: campusSlice,
    careers: careersSlice,
    departments: departmentSlice,
    events: eventsSlice,
    ods: odsSlice,
    modal: modalSlice,
    modalities: modalitiesSlice,
    places: placesSlice,
    progress: progressSlice,
    records: recordSlice,
    search: searchSlice,
    staff: staffSlice,
    students: studentsSlice,
    supervision: supervisionSlice,
    teachers: teachersSlice,
    types: typesSlice,
    thematics: thematicsSlice
})

const reducerProxy = (state, action) => {
    if(action.type === 'auth/logOut'){
        return appReducer(undefined, action);
    }
    return appReducer(state, action)
}

const persistedReducer = persistReducer(persistConfig, reducerProxy)

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => [
        ...getDefaultMiddleware({
            serializableCheck: {
                ignoreActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            }
        })
    ]
})

export const persistor = persistStore(store);